import React from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import { config } from '@Constants/rx-ui/constants';
import BarChartFilterControls from './BarChartFilterControls';
import BarChartFilterGroupItem from './BarChartFilterGroupItem';

import './BarChartFilter.scss';

let spinnerId = 0;

export default function BarChartFilter(props) {
  const { filter, groups, onClickGroup, isGroupsFetching, customFilterConfig, disableControls = false } = props;
  const userInputOpen = filter.get('userInputOpen');

  if (!groups.count()) {
    return (
      <section className="bar-chart-filter-no-filters-found">
        {/* eslint-disable-next-line no-plusplus */}
        {isGroupsFetching && <RxSpinnerComponent autoStart spinnerScale={1} spinnerId={`BarChartFilter-${spinnerId++}`} />}
        No filters were found
      </section>
    );
  }

  const renderFilterItem = (group, disabled = false) => {
    const id = group.get('id');
    return (
      <BarChartFilterGroupItem
        disabled={userInputOpen || disabled}
        onChange={() => onClickGroup(group)}
        group={group}
        key={id}
        customFilterConfig={customFilterConfig}
      />
    );
  };

  return (
    <section className="bar-chart-filter">
      {/* eslint-disable-next-line no-plusplus */}
      {isGroupsFetching && <RxSpinnerComponent autoStart spinnerScale={1} spinnerId={`BarChartFilter-${spinnerId++}`} />}
      <ul className="bar-chart-filter-group">{groups?.take(config.FILTER_MAX_GROUP_COUNT).map((group) => renderFilterItem(group))}</ul>
      {!disableControls && <BarChartFilterControls {...props} />}
    </section>
  );
}

BarChartFilter.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  groups: PropTypes.instanceOf(List).isRequired,
  onClickGroup: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onClickViewMore: PropTypes.func.isRequired,
  onClickUserInput: PropTypes.func.isRequired,
  canRenderViewMore: PropTypes.bool.isRequired,
  disableUserInputToggler: PropTypes.bool.isRequired,
  disableViewMore: PropTypes.bool.isRequired,
  disableControls: PropTypes.bool,
  customFilterConfig: PropTypes.object,
  isGroupsFetching: PropTypes.bool,
};
